import { InjectionToken } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'
import { addIcons } from 'ionicons'
import {
	addCircleOutline,
	appsSharp,
	calendarOutline,
	chevronBackOutline,
	chevronDownOutline,
	chevronForwardOutline,
	chevronUpOutline,
	close as closeIcon,
	closeCircleOutline,
	document as documentIcon,
	ellipsisVertical,
	informationCircleOutline,
	location as locationIcon,
	locationOutline,
	refreshOutline,
	searchOutline,
	timeOutline,
	trashOutline,
	caretForwardOutline,
	eye,
	eyeOff // 👈 importa eyeOff
} from 'ionicons/icons'
import { register } from 'swiper/element'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'

export const CSP_NONCE = new InjectionToken<string>('CSP_NONCE')

// Registra Swiper
register()

/**
 * Lógica para configurar nonce en scripts, estilos, meta tags, etc.
 */
function setupCSPNonce() {
	// 1. Genera un nonce dinámico
	const nonce = crypto.randomUUID()

	const appRoot = document.getElementById('root')
	if (appRoot) {
		appRoot.setAttribute('ngCspNonce', nonce)
	}

	// 2. Meta tag csp-nonce
	const metaNonce = document.querySelector('meta[name="csp-nonce"]')
	if (metaNonce) {
		metaNonce.setAttribute('content', nonce)
	} else {
		const newMeta = document.createElement('meta')
		newMeta.name = 'csp-nonce'
		newMeta.content = nonce
		document.head.appendChild(newMeta)
	}

	// 3. Reemplazar `nonce-placeholder` en meta CSP (si la hay en index.html)
	const metaCSP = document.querySelector('meta[http-equiv="Content-Security-Policy"]')
	if (metaCSP) {
		const content = metaCSP.getAttribute('content') || ''
		metaCSP.setAttribute('content', content.replace(/nonce-placeholder/g, `nonce-${nonce}`))
	}

	// 4. Aplicar el nonce a todos los <script> existentes
	const scripts = document.querySelectorAll('script')
	scripts.forEach(script => {
		if (!script.hasAttribute('nonce')) {
			script.setAttribute('nonce', nonce)
		}
	})

	// 5. Si tienes un script externo (como tu /proxy/externalform.js), añádele nonce
	const externalScript = document.querySelector('script[src="https://testapi-qa-pgc.onetoro.tv/proxy/externalform.js"]')
	if (externalScript) {
		externalScript.setAttribute('nonce', nonce)
	}

	// 6. Aplicar el nonce a los estilos inline existentes
	const styleElements = document.querySelectorAll('style')
	styleElements.forEach(styleElement => {
		if (!styleElement.hasAttribute('nonce')) {
			styleElement.setAttribute('nonce', nonce)
		}
	})

	// 7. Interceptar nuevos <style> insertados dinámicamente
	const originalInsertBefore = document.head.insertBefore.bind(document.head)
	document.head.insertBefore = <T extends Node>(newChild: T, refChild: Node | null): T => {
		if (newChild instanceof Element && newChild.nodeName === 'STYLE' && !newChild.hasAttribute('nonce')) {
			newChild.setAttribute('nonce', nonce)
		}
		return originalInsertBefore(newChild, refChild) as T
	}

	// Retornamos el nonce para utilizarlo durante el bootstrap de la aplicación
	return nonce
}

// Llamamos a la lógica del nonce antes de bootstrapApplication
const nonce = setupCSPNonce()

addIcons({
	addCircleOutline,
	appsSharp,
	calendarOutline,
	chevronBackOutline,
	chevronDownOutline,
	chevronForwardOutline,
	chevronUpOutline,
	close: closeIcon,
	closeCircleOutline,
	document: documentIcon,
	ellipsisVertical,
	informationCircleOutline,
	location: locationIcon,
	locationOutline,
	refreshOutline,
	searchOutline,
	timeOutline,
	trashOutline,
	caretForwardOutline,
	eye,
	'eye-off': eyeOff
})

// 3. Bootstrapping con proveedor del nonce
bootstrapApplication(AppComponent, {
	...appConfig,
	providers: [...(appConfig.providers || []), { provide: CSP_NONCE, useValue: nonce }]
}).catch(err => console.error(err))
// Finalmente, bootstrap de la aplicación
// bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err))
